import clsx from 'clsx';
import PropTypes from 'prop-types';
import CustomText from '@components/shared/CustomText';
import styles from './ErrorText.module.scss';

const ErrorText = ({ bold, customStyle, children, ...props }) => {
  const errorStyle = clsx(styles.text, {
    [customStyle]: !!customStyle,
  });

  return (
    <CustomText bold={bold} className={errorStyle} {...props}>
      {children}
    </CustomText>
  );
};

ErrorText.propTypes = {
  bold: PropTypes.bool,
  children: PropTypes.node,
  customStyle: PropTypes.string,
};

export default ErrorText;
